module.exports = __webpack_public_path__ + "static/img/对号-悬浮_icon_svg.3a79c919.svg";